import React from "react";
import { Menu, Drawer } from "antd";
import type { MenuProps } from "antd";
import {
  UserOutlined,
  FileOutlined,
  ToolFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import Sider from "antd/es/layout/Sider";
// import { usePermissions } from "../../contexts/PermissionContext";

interface AdminSiderProps {
  collapsed: boolean;
  drawerVisible: boolean;
  setDrawerVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

type MenuItem = Required<MenuProps>["items"][number];

const AdminSider: React.FC<AdminSiderProps> = ({
  collapsed,
  drawerVisible,
  setDrawerVisible,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const { hasListPermission, loading } = usePermissions();
  const tabName = location.pathname.replace("/admin/", "").split("/")[0];

  const toggleDrawer = () => setDrawerVisible(!drawerVisible);

  const onSelectMenu = (key: string) => {
    if (key === "map") {
      navigate(`/`);
    } else {
      navigate(`/admin/${key.toLowerCase()}`);
    }
  };

  const getMenuItems = (): MenuItem[] => {
    const items: MenuItem[] = [
      {
        key: 'content',
        label: 'รายการคอนเทนต์',
        type: 'group',
        children: [
          {
            key: "content-list",
            icon: <FileOutlined />,
            label: "ดูรายการคอนเทนต์",
            onClick: () => onSelectMenu("content-list"),
          },
        ],
      },
      {
        key: 'setting',
        label: 'ตั้งค่า',
        type: 'group',
        children: [
          {
            key: "dx-list",
            icon: <ToolFilled />,
            label: "จัดการ DX",
            onClick: () => onSelectMenu("dx-list"),
          },
        ],
      },
      // {
      //   key: 'data-management',
      //   label: 'จัดการข้อมูล',
      //   type: 'group',
      //   children: [
      //     {
      //       key: "roles",
      //       icon: <ToolFilled />,
      //       label: "จัดการสิทธิ์ผู้ใช้งาน",
      //       onClick: () => onSelectMenu("roles"),
      //     },
      //     {
      //       key: "users",
      //       icon: <UserOutlined />,
      //       label: "จัดการผู้ใช้งาน",
      //       onClick: () => onSelectMenu("users"),
      //     },
      //   ],
      // }
    ];

    return items;
  };

  const menuItems = getMenuItems();

  const siderContent = (
    <Menu
      mode="inline"
      style={{ height: "100%", borderRight: 0, textAlign: "start" }}
      selectedKeys={[tabName]}
      items={menuItems}
      theme="light"
    />
  );

  const renderSiderContent = () => {
    return siderContent;
  };

  return (
    <>
      {/* Desktop Sider */}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        width={200}
        className="sider"
        theme="dark"
      >
        {renderSiderContent()}
      </Sider>

      {/* Mobile Drawer */}
      <Drawer
        title="Menu"
        placement="left"
        onClose={toggleDrawer}
        open={drawerVisible}
        width={200}
        style={{ padding: 0 }}
      >
        {renderSiderContent()}
      </Drawer>
    </>
  );
};

export default AdminSider;
